module.exports = __webpack_public_path__ + "static/img/ch-on-joychat.c3e60161.png";